import type { ProductsView } from '../../app/list-views.js';
import type { ViewSetter } from '../../app/view-state.js';
import { ProductsPanel } from './products-panel.js';
import type { InventoryCapabilities } from './shared.js';
import { PageHeader } from '../../app/page-title.js';

/// Produtos no Catálogo, ao lado de Serviços, Pacotes e Promoções (ADR 0055). O cadastro continua
/// do Estoque: só a página saiu das abas dele.
export function CompanyProducts({
  capabilities,
  timeZone,
  view,
  onView,
}: {
  capabilities: InventoryCapabilities;
  timeZone: string;
  view: ProductsView;
  onView: ViewSetter<ProductsView>;
}) {
  return (
    <section aria-labelledby="company-products-title">
      <PageHeader
        trail="Catálogo / Produtos"
        id="company-products-title"
        title="Produtos"
        description="O que a empresa usa e vende, com apresentações, preço de venda e controle por lote."
      />
      <ProductsPanel capabilities={capabilities} timeZone={timeZone} view={view} onView={onView} />
    </section>
  );
}
